/* global scAnalyticsDataArray, digitalData, _satellite, Utils */
import '../../helpers/utils';
import '../analytics-event-handler';
/*
common event handlers for all markets
*/
import CommonFunctions from '../common-functions';

let searchTimer = null;
const productId = 'na';
const productName = 'na';
const africanCountriesList = [ 'bw', 'tz', 'ci', 'ci-fr', 'gh', 'ke', 'ng', 'ug', 'zm', 'zw' ]; //Listing the African markets
const mktCountryCode = typeof window !== 'undefined' ? Utils.getCurrentCountry() : '';

/**
 * check class name and return link type
 * @param {String} className class name of the clicked element
 * @return {String} return link type like link, button, carousel etc
 * @example
 * getCtaType('sc-btn')
 */
const getCtaType = ( className, target ) => {
	if ( target && target.closest( '.sc-nav' ) ) {
		return 'nav-link';
	} else if ( className === '' || typeof className !== 'string' || typeof className.includes === 'undefined' ) {
		return 'link';
	} else if (
		className.indexOf( 'sc-btn' ) !== -1 ||
		className.indexOf( 'c-button' ) !== -1 ||
		( typeof target.className === 'string' && target.className.indexOf( 'ant-btn' ) !== -1 )
	) {
		return 'button';
	} else if ( className.indexOf( 'sc-bnr__link' ) !== -1 || className.indexOf( 'slide-anchor-bg' ) !== -1 ) {
		return 'banner';
	} else if ( className.indexOf( 'sc-carousel__pintiles-item' ) !== -1 ) {
		return 'carousel';
	} else if ( className.indexOf( 'sc-quick-links__link' ) !== -1 ) {
		return 'quick-links';
	} else {
		return 'link';
	}
};

/**
 * based on white list parameters return campaignName and campaignValue
 * @param {Object} allowableQueryString are whitelist parameters
 * @return {Object} return collections of campaignName and campaignValue
 * @example
 * getCampaignInfo(['subChanCode', 'camp_id', 'promoCode'])
 */
const getCampaignInfo = ( allowableQueryString ) => {
	if ( ! allowableQueryString.length ) return '';
	let total = allowableQueryString.length;
	let campaignName = '';
	let campaignValue = '';
	for ( let i = 0; i < total; i++ ) {
		let cookieValue = CommonFunctions.getCookie( allowableQueryString[ i ] );
		if ( cookieValue ) {
			if ( campaignName ) {
				campaignName += ':';
				campaignValue += ':';
			}
			campaignName += allowableQueryString[ i ];
			campaignValue += cookieValue;
		} else {
			let localStorageValue = Utils.getLocalStorageWithExpiry( allowableQueryString[ i ] );
			if ( localStorageValue ) {
				if ( campaignName ) {
					campaignName += ':';
					campaignValue += ':';
				}
				campaignName += allowableQueryString[ i ];
				campaignValue += localStorageValue;
			}
		}
	}
	if ( ! campaignName ) campaignName = 'na';
	if ( ! campaignValue ) campaignValue = 'na';
	return [ campaignName, campaignValue ];
};

/**
 * get external and internal campaign info
 * @example
 * getIntExtCampaignInfo()
 */
const getIntExtCampaignInfo = ( country ) => {
	let allowableQueryString = Utils.constants.ALLOWABLE_QUERYSTRING.scb;
	if ( country === 'pk' ) {
		//Special white listed parameters for PK form only
		allowableQueryString = [
			'intcid',
			'subChanCode',
			'referId',
			'instance',
			'camp_id',
			'pid',
			'promoCode',
			'promo',
			'state',
		];
	}

	let total = allowableQueryString.length;
	let intCampaignName = '';
	let intCampaignValue = '';
	let queryStringList = [];
	let queryString = window.location.search;
	let extCampaignName = '';
	let extCampaignValue = '';

	if ( queryString ) {
		queryString = queryString.substring( 1 );
		if ( queryString ) {
			queryStringList = queryString.split( '&' );
		}
	}
	//Take it from local storage
	for ( let i = 0; i < total; i++ ) {
		let cookieValue = Utils.getCookie( allowableQueryString[ i ] );
		let localStorageValue = Utils.getLocalStorageWithExpiry( allowableQueryString[ i ] );

		if ( cookieValue ) {
			if ( intCampaignName && intCampaignValue ) {
				intCampaignName += ':';
				intCampaignValue += ':';
			}
			intCampaignName += allowableQueryString[ i ];
			intCampaignValue += cookieValue;
		} else if ( localStorageValue ) {
			if ( intCampaignName && intCampaignValue ) {
				intCampaignName += ':';
				intCampaignValue += ':';
			}
			intCampaignName += allowableQueryString[ i ];
			intCampaignValue += localStorageValue;
		} else if ( country === 'pk' ) {
			if ( intCampaignName && intCampaignValue ) {
				intCampaignName += ':';
				intCampaignValue += ':';
			}
			intCampaignName += allowableQueryString[ i ];
			intCampaignValue += 'na';
		}
	}

	//take it from query string
	if ( country === 'pk' ) {
		let allowableQueryString2 = [ 'aggregator_code', 'aggregator_type', 'aggregator_instance' ]; //missing parameter added
		total = allowableQueryString.length;
		for ( let i = 0; i < total; i++ ) {
			if ( intCampaignName ) {
				intCampaignName += ':';
				intCampaignValue += ':';
			}
			intCampaignName += allowableQueryString2[ i ];
			if ( queryStringList.length ) {
				let found = false;
				let result;
				for ( let j = 0; j < queryStringList.length; j++ ) {
					result = queryStringList[ j ].split( '=' );
					if ( result[ 0 ].toLowerCase() === allowableQueryString2[ i ] ) {
						found = true;
						break;
					}
				}
				intCampaignValue += found ? result[ 1 ] : 'na';
			} else {
				intCampaignValue += 'na';
			}
		}
		allowableQueryString.push( allowableQueryString2 );
	}

	//External campaign
	if ( queryStringList.length ) {
		for ( let i = 0; i < queryStringList.length; i++ ) {
			let result = queryStringList[ i ].split( '=' );
			if ( allowableQueryString.indexOf( result[ 0 ] ) === -1 ) {
				//exclude white listed parameters from external campaign
				if ( extCampaignValue !== '' ) {
					extCampaignName += ':';
					extCampaignValue += ':';
				}
				extCampaignName += result[ 0 ];
				extCampaignValue += result[ 1 ];
			}
		}
	}
	if ( extCampaignName === '' ) {
		extCampaignName = 'na';
		extCampaignValue = 'na';
	}
	return {
		intName: intCampaignName.toLowerCase(),
		intVal: intCampaignValue.toLowerCase(),
		extName: extCampaignName.toLowerCase(),
		extVal: extCampaignValue.toLowerCase(),
	};
};

const analyticsOnSubmitForm = ( status, message ) => {
	if ( status === 'error' ) {
		let dataObject = {
			data: {
				error: {
					errorCode: '404',
					errorDescription: message,
				},
			},
			event: 'errorPage',
			title: document.title,
			href: window.location.href,
			context: 'Contact us form submission error',
		};
		scAnalyticsDataArray.push( dataObject );
	}
};

/**
 * Set analytics on click event for the given element
 * @param {Event & {target: HTMLElement}} event dom element event object
 * @param {String} elementType clicked element type
 * @param {string|null=} linkText Link text.
 * @example
 * analyticsOnClickEvent(event)
 */
export const analyticsOnClickEvent = ( event, elementType = null, linkText = null ) => {
	/** @type {string} */
	let customLinkText;

	if ( linkText ) {
		customLinkText = linkText;
	} else {
		customLinkText = ( event?.target?.innerText || event?.target?.textContent )?.trim()?.toLowerCase() || '';
	}

	let ctaType = elementType || getCtaType( '', event.target );
	let linkName =
		document.querySelector( 'title' ) && document.querySelector( 'title' ).innerText
			? document.querySelector( 'title' ).innerText.toLowerCase()
			: 'na';
	let dataObject = {
		...digitalData,
		customLinkClick: {
			customLinkText: customLinkText,
			customLinkRegion:
				CommonFunctions.getHorizontalPosition( event?.clientX ) +
				' ' +
				CommonFunctions.calcElementLocation( event?.target ),
			customLinkType: ctaType,
			customLinkName: linkName,
		},
		event: 'ctaClick',
		title: document.title,
		href: window.location.href,
		context: customLinkText,
	};

	if ( mktCountryCode === 'hk' ) {
		digitalData.ctaName = customLinkText;
		_satellite.track( 'callToAction' );
	} else if ( africanCountriesList.indexOf( mktCountryCode ) > -1 ) { //Creating the digitalData required for Adobe Analytics for African markets.
		let customLinkClick = {
			customLinkName: customLinkText,
			'customLinkPosition': dataObject.customLinkClick.customLinkRegion,
		  };
		digitalData.customLinkClick = customLinkClick;
		let event = {
			eventInfo: {
				eventName: 'ctaClick',
			},
		};
		if ( ! digitalData.event ) {
			digitalData.event = [];
		}
		digitalData.event.push( event );
	} else {
		scAnalyticsDataArray.push( dataObject );
	}
};

export const analyticsSearchTerm = ( keyword, numberOfResults ) => {
	clearTimeout( searchTimer );

	searchTimer = window.setTimeout( function () {
		let event = numberOfResults && numberOfResults !== 'undefined' ? 'siteSearch' : 'zeroSearchResults';

		let dataObject = {
			...digitalData,
			event: event,
			title: document.title,
			href: window.location.href,
			context: keyword,
		};
		dataObject.page.search = {
			keyword: keyword,
			numberOfResults: numberOfResults,
		};

		if ( mktCountryCode === 'hk' ) {
			_satellite.track( 'site-search' );
		} else if ( africanCountriesList.indexOf( mktCountryCode ) > -1 ) { //Creating the digitalData required for Adobe Analytics for African markets.
			let searchInfo = {
				keyword: keyword,
				numberOfResults: numberOfResults,
			  };
			digitalData.page.search = searchInfo;
			let eventInfo = {
				eventInfo: {
					eventName: event,
				},
			};
			if ( ! digitalData.event ) {
				digitalData.event = [];
			}
			digitalData.event.push( eventInfo );
		} else {
			scAnalyticsDataArray.push( dataObject );
		}

	}, 2000 );
};

export const onFormValidationError = () => {
	let customLinkText = document.querySelector( '.sc-contact-us-form-submit' ).innerText;
	let labelText = '';
	let labelValue = '';
	let allFields = document.querySelectorAll( '.ant-form-item-has-error' );

	if ( allFields.length ) {
		for ( let i = 0; i < allFields.length; i++ ) {
			if ( labelText !== '' ) {
				labelText += ':';
				labelValue += ':';
			}
			let title = allFields[ i ].querySelector( 'label' );
			labelText += title ? title.innerText.replace( '*', '' ).trim() : '';
			labelValue += 'validation error';
		}
	}
	labelText = labelText.toLowerCase();
	labelValue = labelValue.toLowerCase();

	digitalData.customLinkClick = {
		customLinkText: customLinkText,
		customLinkRegion: 'right bottom',
		customLinkType: 'button',
	};

	digitalData.error = [];
	let formEfforInfo = {
		errorCode: 'na',
		errorField: labelText,
		errorDescription: labelValue,
	};

	digitalData.error.push( formEfforInfo );

	let dataObject = {
		...digitalData,
		event: 'formError',
	};

	if ( africanCountriesList.indexOf( mktCountryCode ) > -1 ) { //Creating the digitalData required for Adobe Analytics for African markets.
		let customLinkClick = {
			customLinkName: customLinkText,
			'customLinkPosition': dataObject.customLinkClick.customLinkRegion,
		  };
		digitalData.customLinkClick = customLinkClick;
		let event = {
			eventInfo: {
				eventName: 'formError',
			},
		};

		if ( ! digitalData.error ) {
			digitalData.error = [];
		}
		digitalData.error.push( formEfforInfo );

		if ( ! digitalData.event ) {
			digitalData.event = [];
		}
		digitalData.event.push( event );
	} else {
		window.adobeDataLayer.push( dataObject );
		scAnalyticsDataArray.push( dataObject );
	}
};

export const onFormSuccess = ( formData ) => {
	let customLinkText = document.querySelector( '.sc-contact-us-form-submit' ).innerText;

	if ( typeof digitalData == 'object' ) {
		commonAdobeScript();

		delete formData.isinlist;
		let labelText = Object.keys( formData ).join( ':' ).toLowerCase();
		let labelValue = Object.values( formData ).join( ':' ).toLowerCase();

		digitalData.customLinkClick = {
			customLinkText: customLinkText,
			customLinkRegion: 'right bottom',
			customLinkType: 'button',
		};

		digitalData.form.formFields = [];

		let formFields = {
			formFieldName: labelText,
			formFieldValue: labelValue,
		};

		digitalData.form.formFields.push( formFields );

		let dataObject = {
			...digitalData,
			event: 'ctaClick',
		};
		if ( africanCountriesList.indexOf( mktCountryCode ) > -1 ) { //Creating the digitalData required for Adobe Analytics for African markets.
			let customLinkClick = {
				customLinkName: customLinkText,
				'customLinkPosition': dataObject.customLinkClick.customLinkRegion,
			  };
			digitalData.customLinkClick = customLinkClick;
			let event = {
				eventInfo: {
					eventName: 'ctaClick',
				},
			};

			if ( ! digitalData.form.formFields ) {
				digitalData.form.formFields = [];
			}
			digitalData.form.formFields.push( formFields );

			if ( ! digitalData.event ) {
				digitalData.event = [];
			}
			digitalData.event.push( event );
		} else {
			// window.adobeDataLayer.push( dataObject );
			scAnalyticsDataArray.push( dataObject );
		}

		return {
			labelText: labelText,
			labelValue: labelValue,
		};
	}
};

/**
 * trigger after successfully response
 * @param {String} sgrID form id
 * @param {Object} formData collections of form fields name and value
 * @example
 * onFormResponse('530-94', {'name':'test'})
 */
export const onFormResponse = ( sgrID = 'na', formData, appStatus = '_' ) => {
	if ( typeof digitalData == 'object' ) {

		if ( typeof window.digitalData.product[ 0 ] === 'undefined' || ! formData ) {
			return;
		}

		window.digitalData.product[ 0 ].productInfo.appRefNum = sgrID;
		window.digitalData.form.formFields = [];

		delete formData.isinlist;

		let formFields = {
			formFieldName: Object.keys( formData ).join( ':' ).toLowerCase(),
			formFieldValue: Object.values( formData ).join( ':' ).toLowerCase(),
		};

		window.digitalData.form.formFields.push( formFields );

		window.digitalData.form.appStatus = appStatus;

		let dataObject = {
			...digitalData,
			event: 'formSubmit',
		};
		if ( africanCountriesList.indexOf( mktCountryCode ) > -1 ) { //Creating the digitalData required for Adobe Analytics for African markets.
			let event = {
				eventInfo: {
					eventName: 'formSubmit',
				},
			};

			if ( ! digitalData.form.formFields ) {
				digitalData.form.formFields = [];
			}
			digitalData.form.formFields.push( formFields );

			if ( ! digitalData.event ) {
				digitalData.event = [];
			}
			digitalData.event.push( event );
		} else {
			window.adobeDataLayer.push( dataObject );
			scAnalyticsDataArray.push( dataObject );
		}
	}
};

/**
 * generate common object
 * @example
 * commonAdobeScript()
 */
const commonAdobeScript = () => {
	if ( typeof _satellite === 'undefined' ) return;

	if ( typeof window.digitalData == 'object' ) {
		let modularForm = document.querySelector( '.modular-form' );
		window.digitalData.page.pageInfo.buildDetails = 'web3.0';
		window.digitalData.page.pageInfo.libDetails = _satellite.environment.stage;

		getIntExtCampaignInfo();
		let pageName = window.digitalData.page.pageInfo.pageName.split( ':' );
		window.digitalData.product = [];
		window.digitalData.product.push( {
			productInfo: {
				productID: productId,
				productName: productName,
				productCategory: pageName[ 4 ],
				productSubcategory: pageName[ 5 ],
			},
		} );

		window.digitalData.customLinkClick = {
			customLinkText: 'na',
			customLinkRegion: 'na',
			customLinkType: 'na',
		};

		window.digitalData.user = window.digitalData.user || {};
		window.digitalData.user.userInfo = {
			userStatus: 'guest',
			userType: 'NTB',
			segment: pageName[ 2 ],
			loginType: 'na',
			userID: 'na',
		};

		window.digitalData.form = {
			formName: productName === 'na' ? pageName[ 6 ] : productName,
			formStepName: 'na',
			formType: pageName[ 3 ],
			formPlatform: 'udp-form',
			formID: modularForm ? modularForm.getAttribute( 'data-form-id' ) : 'na',
		};
		pageName[ 7 ] = productName === 'na' ? pageName[ 6 ] : productName;
		window.digitalData.page.pageInfo.pageName = pageName.join( ':' );
	}
};

/**
 * Set analytics on page view
 */
export const onPageView = () => {
	analyticsPageViewEvent();
};

/**
 * Send analytics for pageView event
 */
const analyticsPageViewEvent = () => {
	setDigitalDataPageName();
	//Capture campaign
	let allowableQueryString = Utils.constants.ALLOWABLE_QUERYSTRING.scb;
	let pageName = window.digitalData.page.pageInfo.pageName.split( ':' );
	if ( ( pageName[ 0 ] === 'pk' && pageName[ 3 ] === 'udp-form' ) || pageName[ 0 ] === 'in' ) {
		let campaignData = getIntExtCampaignInfo( pageName[ 0 ] );
		window.digitalData.campaign = {
			internal: {
				campaignName: campaignData[ 'intName' ],
				campaignValue: campaignData[ 'intVal' ],
			},
			external: {
				campaignName: campaignData[ 'extName' ],
				campaignValue: campaignData[ 'extVal' ],
			},
		};
	} else {
		let campaignData = getCampaignInfo( allowableQueryString );
		window.digitalData.campaign = window.digitalData.campaign || {};
		window.digitalData.campaign = {
			internal: {
				campaignName: campaignData[ 0 ],
				campaignValue: campaignData[ 1 ],
			},
		};
	}

	let dataObject = {
		...digitalData,
		event: 'pageView',
		title: document.title,
		href: window.location.href,
		context: 'page view',
	};

	if ( window.digitalData.page.pageInfo ) {
		let pageName = window.digitalData.page.pageInfo.pageName.split( ':' );
		if ( pageName[ 4 ] !== 'na' || pageName[ 5 ] !== 'na' || pageName[ 6 ] !== 'na' ) {
			dataObject.product = dataObject.product || {};
			dataObject.product = {
				productInfo: {
					productCategory: pageName[ 4 ],
					productSubcategory: pageName[ 5 ],
					productName: pageName[ 6 ],
					productId: productId,
				},
			};
		}
	}

	if ( mktCountryCode === 'hk' ) {
		_satellite.track( 'page-view' );
	} else if ( africanCountriesList.indexOf( mktCountryCode ) > -1 ) { // page data already being set from setDigitalDataPageName().
		let event = {
			eventInfo: {
				eventName: 'pageView',
			},
		};
		if ( ! digitalData.event ) {
			digitalData.event = [];
		}
		digitalData.event.push( event );
	} else {
		scAnalyticsDataArray.push( dataObject );
	}
};

const setDigitalDataPageName = () => {
	const { country, language, segment, category, subcategory, slug } = Utils.getPageContext();

	/**
	 * Setup PageName for FL AA Tracking
	 *
	 * Syntax: {market}:{language}:{segment}:{page type}:{product category}:{product sub-category}:{product name}:{form name}:{Screen name}
	 */
	window.digitalData.page.pageInfo.pageName = `${ country || '' }:${ language || '' }:${ segment || '' }:product:${
		category || ''
	}:${ subcategory || '' }:funds:na:${ slug || '' }`;

	// Setup other digitalData params
	window.digitalData.page.category.primaryCategory = category;
	window.digitalData.page.category.subCategory = subcategory;
};
